import api from './apiClient';

// Get comprehensive word glossary with variations (tenses, plurals, similar phrases)
const apiGetWordGlossary = async (word, targetLanguage, homeLanguage, definition = '') => {
    const { data } = await api.post('/api/captions/getWordGlossary', {
        word,
        targetLanguage,
        homeLanguage,
        definition,
    });
    return data;
};

export default apiGetWordGlossary;
